


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
             
              <div class="align-items-center">
                <p class="mb-0 text-lg text-center text-black">
                   {{ currentMessages.InvoiceReceiptRequest }} </p>
                <p class="mb-0 text-md text-left text-black">
                 {{ currentMessages.InvoiceReceiptNo }} :  {{ receiptStore.receiptsCode }}
                </p>
                 <p class="mb-0 text-md text-left text-black">
                {{ currentMessages.InvoiceStoreNo }}  :  {{ receiptStore.storeNumber }}
                </p>
              </div>
            </div>
            <div class="card-body mt-1">
             
              <div class="row mb-2">
                <div class="col-6">
                  <div
                    class="border p-2 rounded box-boder"
                    :class="{ 'radio-focused': selectedType === 'NIDN' }"
                  >
                
                      <InputRadio
                      v-model="selectedType"
                      name="customerType"
                      id="personRadio1"
                      value="NIDN"
                    >
                    {{ currentMessages.InvoicePersonType1 }} 
                      
                    </InputRadio>
                  </div>
                </div>

                <div class="col-6">
                  <div
                    class="border p-1 rounded box-boder"
                    :class="{ 'radio-focused': selectedType === 'TXID' }"
                  >
                    <InputRadio
                      v-model="selectedType"
                      name="customerType"
                      id="personRadio2"
                      value="TXID"
                    >
                    {{ currentMessages.InvoicePersonType2 }} 
                      
                    </InputRadio>
                  </div>
                </div>
              </div>

               <!-- <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="full_name" class="form-control-label">
                      
                         {{ currentMessages.InvoiceFullName }} 
                    
                    </label>
                    <InputText
                     v-model="full_name" type="text"  
                     icon="fa fa-user" iconDir="left" 
                     :class="{ 'is-invalid': fullNameError }"
 
                     />
                     <small v-if="fullNameError" class="text-danger">{{ fullNameError }}</small>
                  </div>
                </div> -->

                 <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="full_name" class="form-control-label">
                        {{ selectedType === 'TXID' 
                        ? currentMessages.InvoiceFirstNameType2 
                        : currentMessages.InvoiceFirstName }}
                        <span class="text-danger"> * </span>
                    </label>
                    <InputText
                      v-model="full_name" type="text"  
                      icon="fa fa-user" iconDir="left" 
                      maxlength="256" 
                      :placeholder="selectedType === 'TXID' 
                      ? currentMessages.placeholderFirstNameType2  
                      : currentMessages.placeholderFirstName"
                     :class="{ 'is-invalid': fullNameError }"
 
                     />
                     <small v-if="fullNameError" class="text-danger">{{ fullNameError }}</small>
                  </div>
                </div>


                 <div class="row mt-3" v-if="selectedType === 'NIDN'">
                  <div class="col-md-12">
                      <label for="last_name" class="form-control-label">
                      
                         {{ currentMessages.InvoiceSurname }} 
                       <span class="text-danger"> * </span>
                    </label>
                    <InputText
                     v-model="last_name" type="text"  
                     icon="fa fa-user" iconDir="left" 
                     maxlength="256" 
                     :placeholder="currentMessages.placeholderSurname"
                     :class="{ 'is-invalid': surNameError }"
 
                     />
                     <small v-if="surNameError" class="text-danger">{{ surNameError }}</small>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="tax_id" class="form-control-label">
                    
                          {{ selectedType === 'TXID' 
                        ? currentMessages.InvoiceTaxIDType2 
                        : currentMessages.InvoiceTaxID }}
                      
                    <!-- {{ currentMessages.InvoiceTaxID }}  -->
                    <span class="text-danger"> * </span>
                    </label>
                    <InputText v-model="tax_id"
                     type="text"
                     :class="{ 'is-invalid': taxIDError }"
                      :placeholder="selectedType === 'TXID' 
                      ? currentMessages.InvoiceTaxIDType2  
                      : currentMessages.InvoiceTaxID"
                      maxlength="13"
                     @input="limitTaxIDLength"
                     icon="fa fa-id-card"
                     iconDir="left"/>
                     <small v-if="taxIDError" class="text-danger">{{ taxIDError }}</small>
                  </div>
                </div>

              <div class="row mt-3" v-if="selectedType === 'TXID'">
                <div class="col-md-12">
                  <label for="store_number" class="form-control-label">
                    {{ currentMessages.InvoiceBranchCode }} 
                    <span class="text-danger"> * </span>
                  </label>

                  <InputText 
                    v-model="store_number" 
                    type="text"
                    maxlength="5" 
                    :placeholder="selectedType === 'TXID' 
                      ? currentMessages.InvoiceBranchCode  
                      : currentMessages.InvoiceBranchCode"
                    icon="fa fa-id-card"
                    iconDir="left"
                    :class="{ 'is-invalid': storeNumberErrorKey }"
                  />

                  <small v-if="storeNumberError" class="text-danger">
                    {{ storeNumberError }}
                  </small>
                </div>
              </div>

               
               
                 <div class="row mt-2">
                  <div class="col-md-12">
                     <label for="country" class="form-control-label">
                      
                     {{ currentMessages.InvoiceCountry }} 
                     <!-- <span class="text-danger"> * </span> -->
                    </label>
                      <InputText v-model="country" iconDir="left" :disabled="true">
                        <template #icon>
                          <img :src="IconCountry" alt="Thailand Flag" style="width: 24px; height: auto;" />
                        </template>
                      </InputText>

                  </div>
                </div>


                <div class="row mt-2">
                  <div class="col-md-12">
                     <label for="InvoicePostCode" class="form-control-label">
                     {{ currentMessages.InvoicePostCode }}  
                     <span class="text-danger"> * </span> 
                    </label>
                      <InputText v-model="post_code" 
                        iconDir="left"
                         :placeholder="currentMessages.InvoicePostCode"
                        maxlength="5" 
                        :class="{ 'is-invalid': postCodeError }">
                        <template #icon>
                          <img :src="IconPostCode" alt="Thailand Flag" style="width: 24px; height: auto;" />
                        </template>
                      </InputText>

                         <small v-if="postCodeError" class="text-danger">{{ postCodeError }}</small>

                  </div>
                </div>


                <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="customer_address" 
                      class="form-control-label">
                        {{ selectedType === 'TXID' 
                        ? currentMessages.InvoiceType2Address1 
                        : currentMessages.InvoiceAddress1 }}
                      
                         <span class="text-danger"> * </span>
                    
                    </label>
                   <textarea
                      id="customer_address"
                      v-model="customer_address"
                      :class="{ 'is-invalid': address1Error }"
                      class="form-control"
                      rows="3"
                      limit="256"

                    
                        :placeholder="selectedType === 'TXID' 
                      ? currentMessages.InvoiceType2Address1  
                      : currentMessages.InvoiceAddress1"
                    ></textarea>
                     <small v-if="address1Error" class="text-danger">{{ address1Error }}</small>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="customer_address_2" class="form-control-label">
                      
                        {{ selectedType === 'TXID' 
                        ? currentMessages.InvoiceType2Address2 
                        : currentMessages.InvoiceAddress2 }}
                    
                    </label>
                     <textarea
                      id="customer_address_2"
                      v-model="customer_address_2"
                      class="form-control"
                      rows="3"
                      limit="256"
                      :placeholder="selectedType === 'TXID' 
                      ? currentMessages.InvoiceType2Address2  
                      : currentMessages.InvoiceAddress2"
                    ></textarea>
                  </div>
                </div>


                <div class="row mt-3">
                  <div class="col-md-12">
                     <label for="phone_number" class="form-control-label">
                      
                       {{ selectedType === 'TXID' 
                        ? currentMessages.InvoiceMobilePhoneType2 
                        : currentMessages.InvoiceMobilePhone }}
                      <span class="text-danger"> * </span>
                    </label>
                      <InputText 
                      v-model="phone_number" 
                       :maxlength="selectedType === 'TXID' ? 15 : 10"
                      iconDir="left" 
                      :class="{ 'is-invalid': phoneNumberError }"
                      @input="limitPhoneNumberLength"
                       :placeholder="selectedType === 'TXID' 
                      ? currentMessages.InvoiceMobilePhoneType2  
                      : currentMessages.InvoiceMobilePhone"
                      >
                        <template #icon>
                          <img :src="IconPhone" alt="" style="width: 24px; height: auto;" />
                        </template>
                      </InputText>
                        <small v-if="phoneNumberError" class="text-danger">{{ phoneNumberError }}</small>

                  </div>
                </div>


                 <!-- <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="phone_number" class="form-control-label">
                      
                         {{ currentMessages.InvoiceMobilePhone }} 
                    
                    </label>
                   <InputText v-model="phone_number" type="text"
                    :class="{ 'is-invalid': phoneNumberError }"
                     placeholder="065 883 8043"
                      maxlength="10"
                      @input="limitPhoneNumberLength"
                     icon="fa fa-id-card"
                     iconDir="left"/>
                        <small v-if="phoneNumberError" class="text-danger">{{ phoneNumberError }}</small>
                  </div>
                </div> -->
                <br>
            <div class="custom-checkbox-wrapper">
              <input 
                type="checkbox"
                id="acceptTerms"
                v-model="acceptTerms"
                class="custom-checkbox"
                :class="{ 'invalid': termsErrorKey }"
              />
              <label for="acceptTerms" class="checkbox-label">
                <span style="font-size:12px;" v-html="currentMessages.InvoiceTermAndCordition"></span>
              </label>
            </div>
            <span class="text-danger" style="font-size:12px;">
              {{ currentMessages.InvoiceTermAndCorditionNotice }}
            </span>


            
                              
              <!-- <hr class="horizontal dark" /> -->
           
              <div class="row mb-5 mt-4">
                  <div class="col-md-6">
                      <GlobalButtonPrv @click="handleClickClear">
                       {{ currentMessages.ButtonClear }}  <i class="fa fa-trash" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

                      </GlobalButtonPrv>
                  </div>
                  <div class="col-md-6">
                    <GlobalButtonNext @click="handleClickNextPage">
                       {{ currentMessages.ButtonNext }}  <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                    </GlobalButtonNext>
                </div>
              </div>
             
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

     
    

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import InputText from "@/components/global/InputText.vue";
//import { useRouter } from 'vue-router' 
import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
import { onMounted,ref } from "vue";
import { computed} from "vue";
import InputRadio from "@/components/global/InputRadio.vue";
import IconCountry from '@/assets/img/icons/pages/flag_of_TH.png';
import IconPhone from '@/assets/img/icons/pages/phone.svg';
import IconPostCode from '@/assets/img/icons/pages/icon_postcode.svg';
import { watch } from "vue";
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const receiptStore = useReceiptStoreEtax();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);


const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);
// const handleClickNextPage = () => {
//   emit('preview'); 
// };

//  Default selected type
const selectedType = ref('NIDN');


const store_number = ref('');
const country = ref('');
const customer_address_2 = ref('');

const full_name = ref('');
const fullNameErrorKey = ref('');
const fullNameError = computed(() => {
  return fullNameErrorKey.value ? currentMessages.value[fullNameErrorKey.value] : '';
});


const storeNumberErrorKey = ref('');
const storeNumberError = computed(() => {
  return storeNumberErrorKey.value 
    ? currentMessages.value[storeNumberErrorKey.value] 
    : '';
});


const last_name = ref('');
const surNameErrorKey = ref('');
const surNameError = computed(() => {
  return surNameErrorKey.value ? currentMessages.value[surNameErrorKey.value] : '';
});


const tax_id = ref('');
const taxIDErrorKey = ref('');
const taxIDError = computed(() => {
  return taxIDErrorKey.value ? currentMessages.value[taxIDErrorKey.value] : '';
});

const post_code = ref('');
const postCodeErrorKey = ref('');
const postCodeError = computed(() => {
  return postCodeErrorKey.value ? currentMessages.value[postCodeErrorKey.value] : '';
});


const customer_address = ref('');
const address1ErrorKey = ref('');
const address1Error = computed(() => {
  return address1ErrorKey.value ? currentMessages.value[address1ErrorKey.value] : '';
});

const phone_number = ref('');
const phoneNumberErrorKey = ref('');
const phoneNumberError = computed(() => {
  return phoneNumberErrorKey.value ? currentMessages.value[phoneNumberErrorKey.value] : '';
});


const acceptTerms = ref(false);
const termsErrorKey = ref('');
// const termsError = computed(() => {
//   return termsErrorKey.value ? currentMessages.value[termsErrorKey.value] : '';
// });



const validateForm = () => {
  let valid = true;

  fullNameErrorKey.value = '';
  surNameErrorKey.value = '';
  taxIDErrorKey.value = '';
  postCodeErrorKey.value = '';
  address1ErrorKey.value = '';
  phoneNumberErrorKey.value = '';
  storeNumberErrorKey.value = ''; 
    if (!full_name.value.trim()) {
    fullNameErrorKey.value =
    selectedType.value === 'TXID'
      ? 'ValidationRequiredFullNameType2'
      : 'ValidationRequiredFullName';
  valid = false;
    // fullNameErrorKey.value = 'ValidationRequiredFullName';
    valid = false;
    } else {
    fullNameErrorKey.value = '';
    }
      // ตรวจ surname เฉพาะ NIDN
      if (selectedType.value === 'NIDN') {
        if (!last_name.value.trim()) {
          surNameErrorKey.value = 'ValidationRequiredSurName';
          valid = false;
        } else {
          surNameErrorKey.value = '';
        }
      } else {
        // ถ้าเป็น TXID ไม่ต้องเช็ค surname
        surNameErrorKey.value = '';
      }
    
   if (!/^\d{13}$/.test(tax_id.value)) {
        taxIDErrorKey.value =
          selectedType.value === 'TXID'
            ? 'ValidationRequiredTaxIDType2'
            : 'ValidationRequiredTaxID';
        valid = false;
      } else {
        taxIDErrorKey.value = '';
      }

    if (!/^\d{5}$/.test(post_code.value)) {
      postCodeErrorKey.value = 'ValidationRequiredPostCode'; 
      valid = false;
    } else {
      postCodeErrorKey.value = ''; 
    }

 
    if (!customer_address.value.trim()) {
       address1ErrorKey.value =
      selectedType.value === 'TXID'
      ? 'ValidationRequiredAddress1Type2'
      : 'ValidationRequiredAddress1';
      valid = false;
      } else {
      address1ErrorKey.value = '';
    }
    

   if (selectedType.value === 'TXID') {
  // 9–15 digit
  if (!/^\d{9,15}$/.test(phone_number.value)) {
    phoneNumberErrorKey.value = 'ValidationRequiredPhoneType2';
    valid = false;
  } else {
    phoneNumberErrorKey.value = '';
  }

} else {
  // NIDN = 10 digit
  if (!/^\d{10}$/.test(phone_number.value)) {
    phoneNumberErrorKey.value = 'ValidationRequiredPhone';
    valid = false;
  } else {
    phoneNumberErrorKey.value = '';
  }
}

    // ตรวจ store_number เฉพาะ TXID
   // ตรวจ store_number เฉพาะ TXID
if (selectedType.value === 'TXID') {

  if (!store_number.value.trim()) {
    storeNumberErrorKey.value = 'ValidationRequiredBranchCode';
    valid = false;

  } else if (!/^\d{5}$/.test(store_number.value)) {
    storeNumberErrorKey.value = 'ValidationInvalidBranchCode';
    valid = false;

  } else {
    storeNumberErrorKey.value = '';
  }

  } else {
    storeNumberErrorKey.value = '';
  }


    // if (!store_number.value.trim()) {
    //   storeNumberErrorKey.value = 'ValidationRequiredBranchCode';
    //   valid = false;
    // } else if (!/^\d{5}$/.test(store_number.value)) {
    //   storeNumberErrorKey.value = 'ValidationInvalidBranchCode';
    //   valid = false;
    // }



    if (!acceptTerms.value) {
      termsErrorKey.value = 'InvoiceTermAndCorditionNoticeRecheck';
      valid = false;
    } else {
      termsErrorKey.value = '';
    }


  return valid;
};

const branch_code = ref('');
const handleClickNextPage = () => {
  if (!validateForm()) return;

   receiptStore.$patch({
    receiptsCode: receiptStore.receiptsCode,
    storeNumber: receiptStore.storeNumber,
    selectedType: selectedType.value,
    full_name: full_name.value,
    last_name: last_name.value,
    branch_code: branch_code.value, 
    tax_id: tax_id.value,
    store_number: store_number.value,
    country: country.value,
    post_code: post_code.value,
    customer_address: customer_address.value,
    customer_address_2: customer_address_2.value,
    phone_number: phone_number.value,
  });

  emit('preview');
};
const limitTaxIDLength = (e) => {
  tax_id.value = e.target.value.replace(/\D/g, '').slice(0, 13);
};

const limitPhoneNumberLength = (e) => {
  let val = e.target.value.replace(/\D/g, '');

  if (selectedType.value === 'TXID') {
    // นิติบุคคล: 15 digit max
    phone_number.value = val.slice(0, 15);
  } else {
    // บุคคลทั่วไป: 10 digit fix
    phone_number.value = val.slice(0, 10);
  }
};


const otpCode = ref("");


const handleClickClear = () => {
  // ล้างค่าฟิลด์ทั้งหมด
  selectedType.value = 'NIDN';
  full_name.value = '';
  last_name.value = '';
  tax_id.value = '';
  store_number.value = '';
  branch_code.value = '';
  country.value = 'TH';
  post_code.value = '';
  customer_address.value = '';
  customer_address_2.value = '';
  phone_number.value = '';
  acceptTerms.value = false;

  // ล้างค่า error messages
  fullNameErrorKey.value = '';
  surNameErrorKey.value = '';
  taxIDErrorKey.value = '';
  postCodeErrorKey.value = '';
  address1ErrorKey.value = '';
  phoneNumberErrorKey.value = '';
  termsErrorKey.value = '';

  // // ล้างค่าใน store ด้วย (ถ้าใช้ Pinia)
  // receiptStore.$patch({
  //   selectedType: 'NIDN',
  //   full_name: '',
  //   last_name: '',
  //   tax_id: '',
  //   store_number: '',
  //   branch_code: '',
  //   country: 'TH',
  //   post_code: '',
  //   customer_address: '',
  //   customer_address_2: '',
  //   phone_number: '',
  //   acceptTerms: false,
  // });
};

// Validate Liimt

const removeEmoji = (text) => {
  return text.replace(/[\p{Extended_Pictographic}\p{Emoji_Presentation}]/gu, "");
};

const limitTextLength = (text, max) => {
  return [...text].slice(0, max).join("");
};

const sanitizeInput = (refVar, max, onlyNumber = false) => (e) => {
  let val = e.target.value;

  // remove emoji
  val = removeEmoji(val);

  // only numbers
  if (onlyNumber) {
    val = val.replace(/\D/g, "");
  }

  // limit characters
  val = limitTextLength(val, max);

  refVar.value = val;
};

const sanitizeValue = (val, max, onlyNumber = false) => {
  if (!val) return "";

  val = val.replace(/[\p{Extended_Pictographic}\p{Emoji_Presentation}]/gu, "");

  if (onlyNumber) {
    val = val.replace(/\D/g, "");
  }

  return [...val].slice(0, max).join("");
};

onMounted(() => {
  // โหลดข้อมูลจาก store --> input fields
  selectedType.value = receiptStore.selectedType || 'NIDN';
  full_name.value = receiptStore.full_name || '';
  last_name.value = receiptStore.last_name || '';
  tax_id.value = receiptStore.tax_id || '';
  store_number.value = receiptStore.store_number || '';
  branch_code.value = receiptStore.branch_code || '';

  country.value = receiptStore.country || 'TH';
  post_code.value = receiptStore.post_code || '';
  customer_address.value = receiptStore.customer_address || '';
  customer_address_2.value = receiptStore.customer_address_2 || '';
  phone_number.value = receiptStore.phone_number || '';
});

watch(full_name, (val) => {
  full_name.value = sanitizeValue(val, 256);
});

watch(last_name, (val) => {
  last_name.value = sanitizeValue(val, 256);
});

watch(tax_id, (val) => {
  tax_id.value = sanitizeValue(val, 13, true);
});

watch(store_number, (val) => {
  store_number.value = sanitizeValue(val, 5, true);
});

watch(post_code, (val) => {
  post_code.value = sanitizeValue(val, 5, true);
});

watch(customer_address, (val) => {
  customer_address.value = sanitizeValue(val, 256);
});

watch(selectedType, () => {
  // ถ้ามี error อยู่แล้ว ค่อย update message
  if (fullNameErrorKey.value) {
    fullNameErrorKey.value =
      selectedType.value === 'TXID'
        ? 'ValidationRequiredFullNameType2'
        : 'ValidationRequiredFullName';
  }

  if (address1ErrorKey.value) {
    address1ErrorKey.value =
      selectedType.value === 'TXID'
        ? 'ValidationRequiredAddress1Type2'
        : 'ValidationRequiredAddress1';
  }
});
watch(customer_address_2, (val) => {
  customer_address_2.value = sanitizeValue(val, 256);
});

watch(selectedType, () => {
  if (taxIDErrorKey.value) {
    taxIDErrorKey.value =
      selectedType.value === 'TXID'
        ? 'ValidationRequiredTaxIDType2'
        : 'ValidationRequiredTaxID';
  }
});

watch(selectedType, () => {
  phoneNumberErrorKey.value = '';
});

watch(store_number, (val) => {
  if (selectedType.value !== 'TXID') return;

  if (!val.trim()) {
    storeNumberErrorKey.value = 'ValidationRequiredBranchCode';
  } else if (!/^\d{5}$/.test(val)) {
    storeNumberErrorKey.value = 'ValidationInvalidBranchCode';
  } else {
    storeNumberErrorKey.value = '';
  }
});
</script>
<style scoped>
.radio-focused {
  border-color: orange !important;
  border-width: 2px;
  background-color: #ffffff;
}

.box-boder{
  border-radius: 10px!important;
  padding-left: 1px !important;
  padding-right: 1px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.custom-radio-label {
  
    margin-bottom: 0;
}

.input-border{
    
    border-radius: 10px!important;
  }

.form-check-input.is-invalid {
  border: 2px solid #dc3545 !important;
  box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.25);
  outline: none;
}

.custom-checkbox-wrapper {
  display: flex;
  align-items: center; 
  gap: 8px;          
  margin-top: 10px;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  appearance: none;
  border: 2px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
}

.custom-checkbox:checked {
  background-color: #000000;
  border-color: #000000;
}

.custom-checkbox.invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}

.custom-checkbox::after {
  content: '✔';
  color: white;
  font-size: 12px;
  position: absolute;
  top: -2px;
  left: 2px;
  display: none;
}

.custom-checkbox:checked::after {
  display: block;
}

.checkbox-label {
  margin: 0;
  line-height: 1.4;
  cursor: pointer;
}
.form-control:disabled{
  background-color: white!important;
}

.form-control.input-border.mb-0.form-control-default{
   background-color: white!important;
}
</style>